import { Decision } from "components/Decision";
import { GlobalContext } from "contexts/GlobalContext";
import { Page } from "pages/Page";
import { Fragment, useContext } from "react";
import { Link } from "react-router-dom";
import { RouteList } from "Routes";

const title = "Teacher account required";
const description = "You must be logged in as a teacher to access this page";

export const TeachersPage = () => {
    const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);

    const { isAuthenticated } = useContext(GlobalContext);

    return (
        <Page canonical={window.location.href} description={description} title={title}>
            <div className="container-mini">
                <Decision
                    text={title}
                    description={description}
                    hideGoHome={true}
                    actionElement={
                        <Fragment>
                            {!isAuthenticated && (
                                <Link to={`${RouteList.Login}?returnUrl=${returnUrl}`} className="btn btn-primary">
                                    Login
                                </Link>
                            )}
                        </Fragment>
                    }
                />
            </div>
        </Page>
    );
};
